import React from 'react'

import Spinner from 'react-spinkit'
import enviroment from "../../services/enviroment";

const Loading = ({ loading, message }) => {

    let color = '#296766';
    if (enviroment.isNewUserInterface()) {
        color = '#1E2B4E';
    }

    if (enviroment.isLumiUserInterface()) {
        color = '#0E398D';
    }

    return  (
        <div className='overlay-content' id='Teste' style={{display:"none"}}>
            <div className='wrapper'>
                <Spinner
                    name='cube-grid'
                    fadeIn='none'
                    color={color}
                    style={{width: '60px', height:'60px'}}
                />
                <span className='message'>
                    {message}
                </span>
            </div>
        </div>
    )
}

export default Loading
